const FIELD_LABELS = {
  client_name: 'Client Name',
  role_title: 'Role Title',
  experience_range: 'Experience Range',
  location: 'Location',
  requirement_type: 'Requirement Type',
  deadline: 'Deadline',
  openings: 'Number of Openings',
  assignee_id: 'Assigned Recruiter',
  manual_description: 'Manual JD Description',
  file: 'JD File',
  name: 'Name',
  phone: 'Phone Number',
  email: 'Email',
  skills: 'Skills',
  experience: 'Experience'
};

const REQUIRED_MESSAGES = {
  name: 'Name is required.',
  phone: 'Phone number is required.',
  email: 'Email is required.',
  skills: 'At least one skill is required.'
};

const humanizeField = (field) => {
  if (typeof field !== 'string' && typeof field !== 'number') return null;

  const key = String(field);
  return FIELD_LABELS[key] || key
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, character => character.toUpperCase());
};

export const formatApiErrorDetail = (detail, fallback = 'Failed to upload JD') => {
  if (Array.isArray(detail)) {
    return detail.map(error => {
      const message = error?.msg || error?.message || 'Validation error';
      const location = Array.isArray(error?.loc) ? error.loc : [];
      const field = humanizeField(location[location.length - 1]);
      return field ? `${field}: ${message}` : message;
    }).join(', ');
  }

  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object') {
    const nestedMessage = detail.message || detail.msg || detail.reason || detail.detail;
    if (typeof nestedMessage === 'string') return nestedMessage;
  }
  return fallback;
};

const candidateFieldMessage = (field, error) => {
  const rawMessage = String(error?.msg || error?.message || '').replace(/^Value error,\s*/i, '').trim();
  const isMissing = error?.type === 'missing' || /^field required$/i.test(rawMessage);

  if (isMissing && REQUIRED_MESSAGES[field]) return REQUIRED_MESSAGES[field];
  if (field === 'email' && /valid email|email address|value is not a valid/i.test(rawMessage)) {
    return 'Please enter a valid email address.';
  }
  if (field === 'phone' && rawMessage) return rawMessage.endsWith('.') ? rawMessage : `${rawMessage}.`;
  if (field === 'skills' && rawMessage) return rawMessage.endsWith('.') ? rawMessage : `${rawMessage}.`;
  if (field === 'name' && rawMessage) return rawMessage.endsWith('.') ? rawMessage : `${rawMessage}.`;

  const label = humanizeField(field);
  if (rawMessage) return label ? `${label}: ${rawMessage}` : rawMessage;
  return label ? `${label}: Validation failed.` : 'Validation failed.';
};

export const formatCandidateApiError = (detail, fallback = 'Failed to add candidate.') => {
  if (!Array.isArray(detail)) {
    return {
      fieldErrors: {},
      message: formatApiErrorDetail(detail, fallback)
    };
  }

  const fieldErrors = {};
  const messages = [];

  detail.forEach(error => {
    const location = Array.isArray(error?.loc) ? error.loc : [];
    const field = location[location.length - 1];
    const message = candidateFieldMessage(field, error);
    if (typeof field === 'string' && ['name', 'phone', 'email', 'skills', 'experience'].includes(field)) {
      fieldErrors[field] = message;
    }
    messages.push(message);
  });

  return {
    fieldErrors,
    message: messages.length > 0 ? [...new Set(messages)].join(' ') : fallback
  };
};
